import { create } from "zustand";

interface INicheFollowsStore {
  follows: string[];
  isFetched: boolean;
  isLoading: boolean;
  replaceAllFollows: (follows: string[]) => void;
  follow: (nicheId: string) => void;
  unfollow: (nicheId: string) => void;
  checkFollowing: (nicheId: string) => boolean;
  setFetched: (isFetched: boolean) => void;
  setLoading: (isLoading: boolean) => void;
}

export const useNicheFollowsStore = create<INicheFollowsStore>(
  (set, get) => ({
    follows: [],
    isFetched: false,
    isLoading: false,
    replaceAllFollows: (follows: string[]) => set(() => ({ follows })),
    follow: (nicheId: string) => set((state) => {
      if (!state.follows.includes(nicheId)) {
        return { follows: [...state.follows, nicheId] };
      }

      return state;
    }),
    unfollow: (nicheId: string) => set((state) => {
      if (state.follows.includes(nicheId)) {
        return { follows: state.follows.filter((id) => id !== nicheId) };
      }

      return state;
    }),
    checkFollowing: (nicheId: string) => get().follows.includes(nicheId),
    setFetched: (isFetched: boolean) => set(() => ({ isFetched })),
    setLoading: (isLoading: boolean) => set(() => ({ isLoading })),
  }),
);
